import useTheme from './UseTheme';
export default function useActiveThemeVariation(props, themeAccessor) {
    var theme = useTheme();
    var activeThemeVariation = themeAccessor(theme).getActiveThemeVariation(props);
    return activeThemeVariation;
}
//# sourceMappingURL=UseActiveThemeVariation.js.map